import {
  GetSubAccountsQueryParams,
  SUPPORT_API_LOG_PREFIX,
} from '@twiliointernal/e2-commons-shared-definitions';

import { FetchUserSubaccountsReturn } from '../definitions/types';
import { IdConsole } from '../../../clients';
import { SupportApi } from '@twiliointernal/e2-commons-shared-api';
import { logger } from '@twiliointernal/e2-commons-shared-libs';

const fetchUserSubaccounts = async (
  query: GetSubAccountsQueryParams,
): Promise<FetchUserSubaccountsReturn> => {
  try {
    // No short circuit from SupportApi.* to allow for filtering of subaccounts
    const userSubaccountsResponse = await IdConsole.getSubAccounts(query);

    const isOnSubaccount = !!userSubaccountsResponse.content?.find(
      (subaccount) => subaccount.sid === SupportApi.account?.sid,
    );

    return {
      isOnSubaccount,
      subaccountMetadata: userSubaccountsResponse,
    };
  } catch (err) {
    logger.error(`${SUPPORT_API_LOG_PREFIX}::[fetchUserSubaccounts]::${err}`);
    throw err;
  }
};

export default fetchUserSubaccounts;
